import React from 'react'
import { PackSearchType } from '../../types/pack'
import { SearchListWrapper } from '../../layouts'
import { PackListItem } from '../SearchPreviewItems'

export interface IPackList {
  items: PackSearchType[]
}

export const PackList = ({ items }: IPackList) => (
  <SearchListWrapper>
    {items.map((pack) => (
      <PackListItem key={pack.id} {...pack} />
    ))}
  </SearchListWrapper>
)
